import { StatusLight, StatusLightProps } from '@servicetitan/design-system';
import classNames from 'classnames';
import styles from './StaticStatusLight.module.css';

export const StaticStatusLight = (props: StatusLightProps) => {
  const { children, className, ...restProps } = props;
  return (
    <StatusLight
      className={classNames(styles.staticStatusLight, className)}
      {...restProps}
    >
      {children}
    </StatusLight>
  );
};
